import { AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Directive, Input } from '@angular/core';
import { TemplateBuilderService } from '@app/main/template-editor/services/template-builder.service';

@Directive()
export class ReportItemDirective {
    formGroup: UntypedFormGroup;
    @Input() builder: TemplateBuilderService;
    @Input() index: number;
    @Input() parentIndex: number;
    @Input() disableDelete: boolean;

    @Input() set formItem(control: AbstractControl) {
        this.formGroup = control as UntypedFormGroup;
    }

    get currentLang(): string {
        return this.builder.currentEditingLang;
    }

    removeFromRow() {
        this.builder.removeFromRow(this.formGroup, this.index, this.parentIndex);
    }

    getControl(item: AbstractControl, name: string): UntypedFormControl {
        return item.get(name + (this.currentLang === 'en' ? '' : 'De')) as UntypedFormControl;
    }
}
